import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { ReferenceRateDateType, ReferenceRateUnit } from "__generated__/graphql";

const Options: Record<ReferenceRateUnit, ReferenceRateDateType[]> = {
	[ReferenceRateUnit.Pjk]: [ ReferenceRateDateType.Nomination, ReferenceRateDateType.BlDate ],
	[ReferenceRateUnit.GasolinePrice]: [
		ReferenceRateDateType.ActualDay,
		ReferenceRateDateType.FirstDayOfMonth,
		ReferenceRateDateType.FirstDayPrevMonth,
		ReferenceRateDateType.LastDayPrevMonth,
		ReferenceRateDateType.AveragePrevMonth,
		ReferenceRateDateType.AveragePrevQuarter,
	],
	[ReferenceRateUnit.SpotBarge]: [],
};

const ReferenceRateDateTypeSelect = ({ referenceRateUnit, value, onChange }: Omit<SelectProps<ReferenceRateDateType, false>, "fetchOptions"> & { referenceRateUnit: ReferenceRateUnit }) => {
	return (
		<Select
			fetchOptions={Options[referenceRateUnit]}
			getOptionLabel={(option) => intl.formatMessage({ id: `REFERENCE_RATE_DATE_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default ReferenceRateDateTypeSelect;
